module.exports = __webpack_public_path__ + "img/vertical_4_7_6000.d331f40c.png";